
import { Component, Vue, Watch} from "vue-property-decorator";
import {mdiCogs, mdiArrowUpBold, mdiArrowDownBold, mdiPlus } from "@mdi/js";
import debounce from "debounce";
import SvgIcon from "@jamescoyle/vue-icon";
import { ROWS_PER_PAGE } from "@/utils/constants";
@Component({
    components: {
        SvgIcon,
    },
})
export default class Companies extends Vue {

    @Watch("pagination", {deep: true})
    public handler = debounce((newval: object) => {
        this.getMainData();
    }, 500);

    private rows: object[] = [];
    private showBlockedCompanies: boolean = false;
    private  totalItems: number = 10;
    private headers: object[] = [
        {value: "name", sortable: true},
        {value: "master", sortable: false},
        {value: "activedKeys", sortable: false},
        {value: "transferedKeys", sortable: false},
        {value: "transferedKeysPreviousWeek", sortable: false},
        {value: "transferedKeysVariation", sortable: false},
        {value: "blockedAt", sortable: false},
        {value: "action", sortable: false},
    ];
    private loading: boolean = false;
    private mdiCogs = mdiCogs;
    private mdiArrowUpBold = mdiArrowUpBold;
    private mdiArrowDownBold = mdiArrowDownBold;
    private mdiPlus  = mdiPlus ;
    private pagination: any = {
        sortDesc: [true],
        sortBy: ["updatedAt"],
        search: "",
        page: 1,
        itemsPerPage: 10,
        blocked : this.showBlockedCompanies,
    };

    private ROWS_PER_PAGE = ROWS_PER_PAGE;

    public updateBloquedCompanies() {
        this.pagination.blocked = this.showBlockedCompanies;
    }
    private rowTemplateHandle(item) {
        if (item.transferedKeysVariation > 0) {
            item.icon = mdiArrowUpBold;
            if ( item.transferedKeysVariation <= 50) {
                item.color = "rgb(176, 229, 124)";
            }
            if ( item.transferedKeysVariation  > 50 ) {
                item.color = "green";
            }
        } else if (item.transferedKeysVariation < 0) {
            item.icon = mdiArrowDownBold;
            if ( item.transferedKeysVariation >= -100 && item.transferedKeysVariation <= -50) {
                item.color = "red";
            }
            if ( item.transferedKeysVariation  > -50 ) {
                item.color = "orange";
            }
        }
        return item;
    }
    private logAs(company) {
      const masterId = company.ManagementRelation[0].subordinateId;
      const firstName = company.ManagementRelation[0].Subordinate.firstName;
      const lastName = company.ManagementRelation[0].Subordinate.lastName;
      this.$store.dispatch("auth/logAs", {
        user: {
          id: masterId,
          firstName,
          lastName,
        },
      });
    }
    private getMainData() {
        this.loading = true;
        return this.$store.dispatch("admin/companies/read", {query: this.pagination}).then((res) => {
            this.rows = res.rows;
            this.totalItems = res.count;
            this.loading = false;
        }).catch((err) => {
            this.loading = false;
        });
    }
}
